import { RenderContent } from "components/content-renderer";
import { SharingBar } from "components/sharing-bar";
import { SubscriptionPageSub } from "pages/shop/subscriptions/[slug]";

interface Props {
  subscription: SubscriptionPageSub;
}

export const AboutSection = ({ subscription }: Props) => {
  return (
    <>
      <h1 className='bg-green-default text-white header pt-1 px-1 whitespace-pre-wrap text-2xl  w-full [  ] '>
        {subscription.title}
      </h1>
      {subscription.description && subscription.description !== "" && (
        <div className='prose w-full [  ] '>
          <div className='prose'>
            <RenderContent content={subscription.description} />
          </div>
        </div>
      )}
      <div className='bg-gray-100 flex flex-row space-x-4 py-2 px-1 mb-0 w-full  mt-auto'>
        <span className=''>Share:</span>
        <SharingBar
          className='h-6 '
          url={`/shop/subscriptions/${subscription.slug}`}
          text={`Checkout this great subscription sold by Lighthouse Bookshop (https://lighthousebookshop.com): ${subscription.title}`}
        />
      </div>
    </>
  );
};
